import { createChildListViewContainer } from 'factories/ChildListView'
import actions from 'actions/assets/assetHistory'
import Component from 'components/Assets/History'

export default createChildListViewContainer({ actions })(Component)
